import { ReactNode, useState } from 'react';
import { ArrowsAltOutlined, ShrinkOutlined } from '@ant-design/icons';
import { Button, Popover, PopoverProps, Space } from 'antd';

// trigger should be left to the default value of 'hover' for resize to work
export type ResizablePopoverProps = Omit<PopoverProps, 'title' | 'content | trigger'> & {
  title?: string;
  content: ReactNode;
  maxSize?: { width: number; height: number };
};

const DEFAULT_WINDOW_SIZE = { width: 450, height: 350 };
const MAX_WINDOW_SIZE = { width: 800, height: 600 };

export const ResizablePopover = ({
  title,
  content,
  maxSize = MAX_WINDOW_SIZE,
  children,
  ...restProps
}: ResizablePopoverProps) => {
  const [isMaximized, setIsMaximized] = useState(false);
  const modalSize = isMaximized ? maxSize : DEFAULT_WINDOW_SIZE;

  return (
    <Popover
      title={
        <>
          <span>{title}</span>
          <Space style={{ float: 'right' }}>
            <Button
              icon={isMaximized ? <ShrinkOutlined /> : <ArrowsAltOutlined />}
              size="small"
              onClick={(e) => setIsMaximized((prev) => !prev)}
            />
          </Space>
        </>
      }
      content={<div style={{ ...modalSize, overflow: 'auto' }}>{content}</div>}
      trigger="click"
      {...restProps}
    >
      {children}
    </Popover>
  );
};
